import { render, staticRenderFns } from "./examine.vue?vue&type=template&id=48735eff&scoped=true&"
import script from "./examine.vue?vue&type=script&lang=js&"
export * from "./examine.vue?vue&type=script&lang=js&"
import style0 from "./examine.vue?vue&type=style&index=0&id=48735eff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48735eff",
  null
  
)

export default component.exports